import { WatsonHealth3DMprToggle } from '@carbon/icons-react';
import { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import LinearProgress from '@mui/material/LinearProgress';
import { useTheme } from '@mui/material/styles';
import * as Preact from 'preact';
import * as Button from './A_Button';
import { isSmallScreen } from './domain/theme/breakpoints';
import { ArModal } from './index';
import * as ArCard from './A_ARDesktopBasket'

export interface Props {
    sofaSnapshot?: string;
    snapshotLoading: boolean;
    linkProps: (ArModal.ArProps | ArModal.QrProps);
    onViewInRoomClick?: () => void;
    sx?: SxProps;
}

export const Component = (p: Props) => {
    const theme = useTheme();
    const isSmall = isSmallScreen(theme);

    return (
        <Card
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'inherit',
                ...p.sx,
            }}
        >
            {p.snapshotLoading ? (
                <Box
                    sx={{
                        height: isSmall ? '270px' : '100%',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <LinearProgress sx={{ width: '100%' }} />
                </Box>
            ) : (
                <CardMedia
                    sx={{ height: isSmall ? '270px' : '100%', backgroundSize: 'contain' }}
                    image={p.sofaSnapshot}
                />
            )}

            {isSmall ? (
                // TODO: Add function prop to open AR.
                <Button.Component
                    variant="contained"
                    color="secondary"
                    startIcon={<WatsonHealth3DMprToggle size="20" />}
                    sx={{
                        width: 'fit-content',
                        margin: 'auto',
                        height: '40px',
                        backgroundColor: 'white !important',
                        borderRadius: '100px',
                    }}
                    onClick={p.onViewInRoomClick}
                >
                    View in room
                </Button.Component>
            ) : (p.linkProps.mode === 'qr' && <ArCard.Component loading={p.linkProps.loading} qrUrl={p.linkProps.qrCode}/>)}
        </Card>
    );
};

Component.displayName = 'SofaSnapshot';
